<section class="ui-document-folder-list">
  <div class="ui-document-folder-list__body">
    <nav
      class="ui-document-folder-list__status-nav"
      aria-label="Estatus de documentos"
    >
      @for (entry of statusNav(); track entry.key) {
        <button
          type="button"
          class="ui-document-folder-list__status-item"
          [class.ui-document-folder-list__status-item--all]="entry.key === 'all'"
          [class.ui-document-folder-list__status-item--current]="
            entry.key === 'current'
          "
          [class.ui-document-folder-list__status-item--none]="entry.key === 'none'"
          [class.ui-document-folder-list__status-item--pending]="
            entry.key === 'pending'
          "
          [class.ui-document-folder-list__status-item--expired]="
            entry.key === 'expired'
          "
          [class.ui-document-folder-list__status-item--active]="
            statusFilter() === entry.key
          "
          (click)="selectStatus(entry.key)"
        >
          <span>{{ entry.label }}</span>
          <span
            class="ui-document-folder-list__status-count"
            [class.ui-document-folder-list__status-count--all]="
              entry.key === 'all'
            "
            [class.ui-document-folder-list__status-count--current]="
              entry.key === 'current'
            "
            [class.ui-document-folder-list__status-count--none]="
              entry.key === 'none'
            "
            [class.ui-document-folder-list__status-count--pending]="
              entry.key === 'pending'
            "
            [class.ui-document-folder-list__status-count--expired]="
              entry.key === 'expired'
            "
          >{{ entry.count }}</span>
        </button>
      }
    </nav>

    <div class="ui-document-folder-list__main">
      @if (selectedFolder(); as folder) {
        <div class="ui-document-folder-list__toolbar">
          <div class="ui-document-folder-list__toolbar-start">
            <button
              type="button"
              class="ui-document-folder-list__excel"
              [uiTooltip]="'Exportar a Excel'"
              uiTooltipPosition="top"
              aria-label="Exportar a Excel"
              (click)="exportExcel.emit()"
            >
              <img
                src="icons/ic_excel.svg"
                alt=""
                width="20"
                height="19"
                aria-hidden="true"
              />
            </button>
            <h2 class="ui-document-folder-list__files-title" [title]="folder.title">
              {{ folder.title }}
            </h2>
          </div>
          <div class="ui-document-folder-list__toolbar-end">
            <ui-button variant="secondary" size="sm" (pressed)="closeFolder()">
              Regresar
            </ui-button>
            <ui-button variant="primary" size="sm" (pressed)="openNewDocument()">
              Nuevo
            </ui-button>
          </div>
        </div>

        <div class="ui-document-folder-list__scroll">
          @if (selectedFiles().length) {
            <table class="ui-document-folder-list__table">
              <colgroup>
                <col />
                <col class="ui-document-folder-list__file-col--size" />
                <col class="ui-document-folder-list__file-col--updated" />
                <col class="ui-document-folder-list__file-col--validity" />
                <col class="ui-document-folder-list__file-col--status" />
                <col class="ui-document-folder-list__file-col--actions" />
              </colgroup>
              <thead>
                <tr class="ui-document-folder-list__files-head">
                  <th>Documento</th>
                  <th>Tamaño</th>
                  <th>Fecha actualización</th>
                  <th>Fecha vigencia</th>
                  <th>Estatus</th>
                  <th class="ui-document-folder-list__th-actions"></th>
                </tr>
              </thead>
              <tbody>
                @for (file of selectedFiles(); track file.id; let idx = $index) {
                  <tr
                    class="ui-document-folder-list__file-row"
                    [class.ui-document-folder-list__file-row--menu-open]="
                      fileMenu()?.rowIndex === idx
                    "
                  >
                    <td>
                      <div class="ui-document-folder-list__file-doc">
                        <img
                          class="ui-document-folder-list__file-icon"
                          [src]="fileIcon(file.kind)"
                          alt=""
                          width="20"
                          height="20"
                          aria-hidden="true"
                        />
                        <span [title]="file.name">{{ file.name }}</span>
                      </div>
                    </td>
                    <td>{{ file.size }}</td>
                    <td>{{ file.date }}</td>
                    <td>{{ file.validityDate }}</td>
                    <td>
                      <ui-tag
                        [label]="file.status"
                        [color]="fileStatusColor(file.status)"
                        appearance="outline"
                      />
                    </td>
                    <td
                      class="ui-document-folder-list__td-actions"
                      [class.ui-document-folder-list__td-actions--open]="
                        fileMenu()?.rowIndex === idx
                      "
                      (click)="$event.stopPropagation()"
                    >
                      <button
                        type="button"
                        class="ui-document-folder-list__file-trigger"
                        [attr.aria-label]="'Acciones de ' + file.name"
                        [attr.aria-expanded]="fileMenu()?.rowIndex === idx"
                        aria-haspopup="menu"
                        (click)="toggleFileMenu($event, file, idx)"
                      >
                        ⋮
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p class="ui-document-folder-list__empty">
              No se encontraron archivos.
            </p>
          }
        </div>
      } @else {
        <div class="ui-document-folder-list__toolbar">
          <div class="ui-document-folder-list__toolbar-start">
            <button
              type="button"
              class="ui-document-folder-list__excel"
              [uiTooltip]="'Exportar a Excel'"
              uiTooltipPosition="top"
              aria-label="Exportar a Excel"
              (click)="exportExcel.emit()"
            >
              <img
                src="icons/ic_excel.svg"
                alt=""
                width="20"
                height="19"
                aria-hidden="true"
              />
            </button>
          </div>

          <div class="ui-document-folder-list__toolbar-end">
            <ui-select
              class="ui-document-folder-list__page-size"
              [showLabel]="false"
              [showSearch]="false"
              [allowClear]="false"
              [options]="pageSizeOptions"
              [selected]="selectedSizeOption()"
              (selectedChange)="onPageSizeChange($event)"
              [style.width.px]="145"
            />
            <ui-input
              class="ui-document-folder-list__search"
              kind="search"
              label="Buscar"
              placeholder="Buscar documentos"
              [showLabel]="false"
              [showOptionalHint]="false"
              [value]="search()"
              (valueChange)="onSearch($event)"
            />
          </div>
        </div>

        <div class="ui-document-folder-list__scroll">
        <div class="ui-document-folder-list__list" role="list">
          <div class="ui-document-folder-list__head" role="row">
            <span class="ui-document-folder-list__head-icon" aria-hidden="true"></span>
            <span class="ui-document-folder-list__col-document">Documento</span>
            <span class="ui-document-folder-list__col-type">Tipo</span>
            <span class="ui-document-folder-list__col-validity">Vigencia</span>
            <span class="ui-document-folder-list__col-updated">Última actualización</span>
            <span class="ui-document-folder-list__col-docs">Documentos</span>
            <span class="ui-document-folder-list__col-status">Estatus</span>
          </div>

          <div class="ui-document-folder-list__filters" role="row">
            <span class="ui-document-folder-list__filter-cell" aria-hidden="true"></span>
            <div class="ui-document-folder-list__filter-cell">
              <ui-multiselect
                class="ui-document-folder-list__filter-multiselect"
                [options]="documentFilterOptions()"
                [selected]="columnFilterSelected('document')"
                [showLabel]="false"
                [showOptionalHint]="false"
                [showMessage]="false"
                [block]="true"
                [fitPanelToContent]="true"
                [maxChipsVisible]="1"
                placeholder="Todos"
                (selectedChange)="onColumnFilterMulti('document', $event)"
              />
            </div>
            <div class="ui-document-folder-list__filter-cell">
              <ui-multiselect
                class="ui-document-folder-list__filter-multiselect"
                [options]="typeFilterOptions"
                [selected]="columnFilterSelected('type')"
                [showLabel]="false"
                [showOptionalHint]="false"
                [showMessage]="false"
                [block]="true"
                [fitPanelToContent]="true"
                [maxChipsVisible]="1"
                placeholder="Todos"
                (selectedChange)="onColumnFilterMulti('type', $event)"
              />
            </div>
            <label class="ui-document-folder-list__filter-cell">
              <input
                class="ui-document-folder-list__filter-input"
                type="text"
                placeholder="Buscar..."
                aria-label="Buscar vigencia"
                [value]="columnFilters().validity"
                (input)="onColumnFilter('validity', $any($event.target).value)"
              />
            </label>
            <label class="ui-document-folder-list__filter-cell">
              <input
                class="ui-document-folder-list__filter-input"
                type="text"
                placeholder="Buscar..."
                aria-label="Buscar última actualización"
                [value]="columnFilters().updated"
                (input)="onColumnFilter('updated', $any($event.target).value)"
              />
            </label>
            <div class="ui-document-folder-list__filter-cell">
              <ui-multiselect
                class="ui-document-folder-list__filter-multiselect"
                [options]="docsFilterOptions()"
                [selected]="columnFilterSelected('docs')"
                [showLabel]="false"
                [showOptionalHint]="false"
                [showMessage]="false"
                [block]="true"
                [fitPanelToContent]="true"
                [maxChipsVisible]="1"
                placeholder="Todos"
                (selectedChange)="onColumnFilterMulti('docs', $event)"
              />
            </div>
            <div class="ui-document-folder-list__filter-cell">
              <ui-multiselect
                class="ui-document-folder-list__filter-multiselect"
                [options]="statusFilterOptions"
                [selected]="columnFilterSelected('status')"
                [showLabel]="false"
                [showOptionalHint]="false"
                [showMessage]="false"
                [block]="true"
                [fitPanelToContent]="true"
                [maxChipsVisible]="1"
                placeholder="Todos"
                (selectedChange)="onColumnFilterMulti('status', $event)"
              />
            </div>
          </div>

          @if (pagedItems().length) {
          @for (item of pagedItems(); track item.id) {
            <article
              class="ui-document-folder-list__row"
              [class.ui-document-folder-list__row--current]="
                item.status === 'Vigente'
              "
              [class.ui-document-folder-list__row--expired]="
                item.status === 'Vencido'
              "
              role="button"
              tabindex="0"
              [attr.aria-label]="'Abrir archivos de ' + item.title"
              (click)="openFolder(item)"
              (keydown.enter)="openFolder(item)"
              (keydown.space)="$event.preventDefault(); openFolder(item)"
            >
              <div class="ui-document-folder-list__icon" aria-hidden="true">
                <span class="ui-document-folder-list__icon-glyph"></span>
              </div>

              <h3
                class="ui-document-folder-list__title ui-document-folder-list__col-document"
                [title]="item.title"
              >
                {{ item.title }}
              </h3>

              <span class="ui-document-folder-list__type ui-document-folder-list__col-type">
                {{ item.type }}
              </span>
              <span
                class="ui-document-folder-list__validity-value ui-document-folder-list__col-validity"
                [title]="validityLabel(item)"
              >
                {{ validityLabel(item) }}
              </span>

              <p class="ui-document-folder-list__updated ui-document-folder-list__col-updated">
                {{ item.lastUpdated }}
              </p>

              <span
                class="ui-document-folder-list__attachments ui-document-folder-list__col-docs"
              >
                <span class="ui-document-folder-list__count">
                  {{ item.attachments }}
                </span>
              </span>

              <div class="ui-document-folder-list__status ui-document-folder-list__col-status">
                @if (isPending(item)) {
                  <ui-tag
                    label="Pendiente"
                    color="warning"
                    appearance="outline"
                  />
                } @else if (item.status; as status) {
                  <ui-tag
                    [label]="status"
                    [color]="statusColor(item)"
                    appearance="outline"
                  />
                }
              </div>
            </article>
          }
      } @else {
          <p class="ui-document-folder-list__empty">
            No se encontraron documentos.
          </p>
      }
        </div>
        </div>

        <ui-data-table-pagination
          [currentPage]="safePage()"
          [totalPages]="totalPages()"
          [visiblePages]="visiblePages()"
          [rangeStart]="rangeStart()"
          [rangeEnd]="rangeEnd()"
          [total]="total()"
          (pageSelect)="goToPage($event)"
        />
      }
    </div>
  </div>
</section>

<ui-drawer
  [(open)]="newDocumentOpen"
  title="Nuevo documento"
  cancelLabel="Cerrar"
  saveLabel="Guardar"
>
  <div class="ui-document-folder-list__new-form">
    <ui-form-section title="Generales">
      @if (selectedFolder()?.validity === 'Con vigencia') {
        <ui-date-input
          label="Vigencia"
          kind="date"
          [required]="true"
          [block]="true"
          [(value)]="newDocumentValidity"
        />
      }
      <ui-file-upload
        label="Archivo"
        [required]="true"
        [multiple]="false"
        [block]="true"
        [(value)]="newDocumentFiles"
      />
    </ui-form-section>

    <ui-form-section title="Notas">
      <ui-textarea
        label="Notas"
        [block]="true"
        [(value)]="newDocumentNotes"
      />
    </ui-form-section>
  </div>
</ui-drawer>

@if (fileMenu(); as menu) {
  <ui-data-table-actions-menu
    [state]="menu"
    [items]="menu.items"
    (actionSelect)="onFileMenuAction($event)"
  />
}
